import { Field, reduxForm } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import InputField from 'client/features/form/components/InputField.jsx'
import { connect } from 'react-redux'
import REGEXP from 'constant/REGEXP'

const validate = values => {
    const errors = {}
    if (!values.name) errors.name = 'Name required'
    return errors
}

class ClientName extends Component {
    constructor() {
        super()
        this.onChange = this.onChange.bind(this)
        this.submit = this.submit.bind(this)
        this.state = {
            lastChange: null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.initialValues._id !== nextProps.initialValues._id)
            this.props.initialize(nextProps.initialValues)
    }

    onChange() {
        const now = new Date().getTime()
        this.setState({ lastChange: now })
        setTimeout(() => this.state.lastChange && this.state.lastChange === now ? this.submit() : null, 1000)
    }

    submit() {
        this.setState({ lastChange: null })
        this.props.submit()
    }

    render() {
        const { handleSubmit } = this.props
        return (
            <form onSubmit={ handleSubmit } className='inline-block m-b-0' style={ { width: '80%' } } onChange={ this.onChange }>
                <Field name='name' component={ InputField } type='text' placeholder='Name...' className='content-editable' containerClassName='ce' divClass='ce' autoComplete='off'/>
            </form>
        )
    }
}

ClientName.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
} 

ClientName = reduxForm({
    form: 'clientName',
    validate
})(ClientName)

const mapStateToProps = (state) => {
    const initialValues = state.client.current
    return {
        initialValues
    }
}

export default connect(mapStateToProps)(ClientName)


// WEBPACK FOOTER //
// ./src/client/features/client/components/ClientName.jsx